var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BIcon',_vm._b({attrs:{"icon":_vm.icon}},'BIcon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }